module.exports = __webpack_public_path__ + "img/eye.3dc414da.svg";